export * from './integration-blank.component';